import { useEffect, useState } from "react";
import "./Accordion.css";

const Accordion = ({ items = [], keepOthersOpen = false }) => {
  const [accordionItems, setAccordionItems] = useState([]);

  useEffect(() => {
    setAccordionItems(
      (items ?? []).map((item) => ({
        ...item,
        toggled: false,
      }))
    );
  }, [items]);

  function handleAccordionToggle(clickedItem) {
    setAccordionItems((prev) =>
      prev.map((item) => {
        let toggled = item.toggled;

        if (clickedItem.id === item.id) toggled = !item.toggled;
        else if (!keepOthersOpen) toggled = false;

        return { ...item, toggled };
      })
    );
  }

  return (
    <div className="accordion-parent">
      {accordionItems.map((listItem) => (
        <div
          key={listItem.id}
          className={`accordion ${listItem.toggled ? "toggled" : ""}`}
        >
          <button
            className="toggle"
            onClick={() => handleAccordionToggle(listItem)}
          >
            <p>{listItem.label}</p>
            <div className="directionIndicator">
              {listItem.toggled ? "-" : "+"}
            </div>
          </button>

          <div className="content-parent">
              <div className="content">
                  {(listItem.items ?? []).map((item, i) => {
                      if (typeof item === "string") {
                          return <p className="rule-text" key={i}>{item}</p>;
                      }

                      if (item.type === "list") {
                          return (
                              <ul className="rule-list" key={i}>
                                  {(item.items ?? []).map((li, j) => (
                                      <li className="rule-text" key={j}>
                                          {li}
                                      </li>
                                  ))}
                              </ul>
                          );
                      }

                      if (item.type === "text") {
                          return <p className="rule-text" key={i}>{item.value}</p>;
                      }

                      if (item.type === "table") {
                          return (
                              <div className="table-wrap" key={i}>
                                  <table className="rule-table">
                                      <thead>
                                      <tr>
                                          {item.headers.map((h, j) => (
                                              <th key={j}>{h}</th>
                                          ))}
                                      </tr>
                                      </thead>
                                      <tbody>
                                      {item.rows.map((row, r) => (
                                          <tr key={r}>
                                              {row.map((cell, c) => (
                                                  <td key={c}>{cell}</td>
                                              ))}
                                          </tr>
                                      ))}
                                      </tbody>
                                  </table>
                              </div>
                          );
                      }
                      return null;
                  })}
              </div>          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;